import { updateWidget } from '@wix/ambassador-genie-chat-service-v1-no-entity/http';
import { RUN_TASK_WIDGET_ID } from '../constants';
export async function updateWidgetInConversation(_ref) {
  let {
    conversationId,
    invocationId,
    data,
    config,
    entries,
    httpClient
  } = _ref;
  const selector = JSON.stringify({
    'data.invocationId': invocationId
  });
  const updatedEntries = entries.map(entry => {
    const updatedEntry = {
      ...entry
    };

    // Don't include payloads as they are too large for `updateWidget` call
    delete updatedEntry.requestPayload;
    delete updatedEntry.resultPayload;
    return updatedEntry;
  });
  const updatedData = {
    ...data,
    invocationId,
    entries: updatedEntries
  };
  const updatedConfig = {
    ...('borderless' in config && {
      borderless: config.borderless
    })
  };
  const widget = JSON.stringify({
    widget: RUN_TASK_WIDGET_ID,
    data: updatedData,
    config: updatedConfig
  });
  await httpClient.request(updateWidget({
    conversationId,
    selector,
    widget,
    agentName: 'rootAgent'
  }));
}
//# sourceMappingURL=updateWidgetInConversation.js.map